export default __webpack_public_path__ + "static/media/Close.e20279ac.svg";